import React, { FC, PropsWithChildren, useState } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import messages from '../messages';

import DropdownToggler from './dropdownToggler/DropdownToggler';

import { ContentBodyWrapper, ContentHeader, ContentWrapper, InfoDropdownWrapper } from './styles';

type InfoDropdownProps = PropsWithChildren & {
    dropdownId: 'playoffFormat' | 'tieBreaking';
};

const InfoDropdown: FC<InfoDropdownProps> = ({ children, dropdownId }) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    return (
        <InfoDropdownWrapper id={dropdownId} $isOpen={isOpen} role="complementary">
            <div>
                <DropdownToggler dropdownId={dropdownId} isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
            <ContentWrapper role="group">
                <ContentHeader aria-level={2}>
                    <label htmlFor={dropdownId}>
                        <FormattedMessage {...messages.ariaLabels[dropdownId].header} />
                    </label>
                </ContentHeader>
                <ContentBodyWrapper
                    id="content-body-wrapper"
                    aria-expanded={isOpen ? 'true' : 'false'}
                    aria-hidden={isOpen ? 'false' : 'true'}
                    aria-label={intl.formatMessage(messages.ariaLabels[dropdownId].body)}
                    role="group"
                >
                    {children}
                </ContentBodyWrapper>
            </ContentWrapper>
        </InfoDropdownWrapper>
    );
};

export default InfoDropdown;
